import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import Transport from '../entities/transport';
import TransportDetail from '../entities/transportdetail';
import TransportStatus from '../entities/transportstatus'
import Ref from '../entities/ref'
interface TransportState extends ListState<Transport>{
    editTransport:Transport,
    viewTransport: Transport,
    transportStatuses: TransportStatus[],
    transportTypes : Ref[]
}
class TransportMutations extends ListMutations<Transport>{

}
class TransportModule extends ListModule<TransportState,any,Transport>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Transport>(),
        loading:false,
        editTransport:new Transport(),
        viewTransport: new Transport(),
        transportStatuses: new Array<TransportStatus>(),
        transportTypes: new Array<Ref>()
    }
    actions={
        async getAll(context:ActionContext<TransportState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Transport/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Transport>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<TransportState,any>,payload:any){
            await Ajax.post('/api/services/app/Transport/Create',payload.data);
        },
        async update(context:ActionContext<TransportState,any>,payload:any){
            await Ajax.put('/api/services/app/Transport/Update',payload.data);
        },
        async delete(context:ActionContext<TransportState,any>,payload:any){
            await Ajax.delete('/api/services/app/Transport/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<TransportState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Transport/GetDetail?Id='+payload.data.id);
            return reponse.data.result as TransportDetail;
        },
        async getTransportStatuses(context:ActionContext<TransportState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Transport/GetTransportStatuses',{params:payload.data});
            context.state.transportStatuses=reponse.data.result as TransportStatus[];
        },
        async getTransportTypes(context:ActionContext<TransportState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Ref/Transport/TransportType',{params:payload.data});
            context.state.transportTypes=reponse.data.result.items as Ref[];
        },
        async updateStatusTransportToPutAway(context:ActionContext<TransportState,any>,payload:any){
            await Ajax.post('/api/services/app/Transport/updateStatusTransportToPutAway', payload.data);
        },
    };
    mutations={
        setCurrentPage(state:TransportState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:TransportState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:TransportState,transport:Transport){
            state.editTransport=transport;
        },
        view(state: TransportState, transport:Transport) {
            state.viewTransport = transport;
          }
    }
}
const transportModule=new TransportModule();
export default transportModule;